module.exports = __webpack_public_path__ + "static/img/pay-cn-btn.506330d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pay/pay-cn-btn.png
// module id = EUv0
// module chunks = 1